<template>
  <div class="srm-container">
    <s-r-m-header ref="header" activeVal="purvarPlm"/>
    <carousel-container ref="carouselContainer" :banner-height="bannerHeight" />
    <characteristic ref="characteristic" id="home-characteristic" />
    <p-l-m-a-i-application theme="white" />
    <app-benefits ref="appBenefits" />
    <advantage ref="advantage" />
    <!-- <product-features
      title="产品功能"
      description="PLM产品生命周期管理产品数据管理、项目协同管理、研发管理、设计工具集成"
      :tabList="tabList"
    ></product-features> -->
    <!-- <Scheme :schemeList="schemeList"></Scheme> -->
    <!-- <SystemFunction
      :systemInfo="systemInfo"
    ></SystemFunction> -->
    <ClassicCase :banner-height="bannerHeight2"></ClassicCase>
    <ChooseUs id="home-logo-wall"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box />
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/index"
import Advantage from "@/components/Advantage/index"
import Characteristic from "@/components/Characteristic/index"
import AppBenefits from "@/components/AppBenefits"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import ProductFeatures from "@/components/ProductFeatures"
import Scheme from "@/components/Scheme"
import SystemFunction from "@/components/SystemFunction"
import ClassicCase from "@/components/ClassicCase"
import ChooseUs from "@/components/ChooseUs"
import PLMAIApplication from "@/components/PLMAIApplication"
import { baiduConsult } from "./common.js";

import hg1 from '@/assets/images/hg1.png'
import hg2 from '@/assets/images/hg2.png'
import hg3 from '@/assets/images/hg3.png'
import hg4 from '@/assets/images/hg4.png'
import hg5 from '@/assets/images/hg5.png'

import dz1 from '@/assets/images/dz1.png'
import dz2 from '@/assets/images/dz2.png'
import dz3 from '@/assets/images/dz3.png'
import dz4 from '@/assets/images/dz4.png'
import dz5 from '@/assets/images/dz5.png'
import dz6 from '@/assets/images/dz6.png'

import gnt1 from '@/assets/images/gnt1.png'

export default {
  components: {
    SRMHeader,
    CarouselContainer,
    Advantage,
    Characteristic,
    AppBenefits,
    CustomForm,
    FooterBox,
    ProductFeatures,
    Scheme,
    SystemFunction,
    ClassicCase,
    ChooseUs,
    PLMAIApplication
  },
  metaInfo() {
    return {
      title: '化工材料PLM_食品饮料PLM_日化美妆PLM_流程行业PLM国产供应商_研发管理平台（系统软件）',
      meta: [
        {
          name: 'keywords',
          content: 'PLM系统,PMS软件,产品生命周期管理,研发管理平台,化工材料行业PLM,食品饮料行业PLM,日化美妆行业PLM'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM，基于AI智能合规引擎与全流程数字化技术，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业（化工材料、食品、饮料、日化、美妆等）、芯片半导体行业、医疗器械行业、电子高科技行业等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      ratio: null,
      bannerHeight: null,
      bannerHeight2: null,
      tabList: [
        {
          name: 'first',
          label: '数据管理',
          title: '以数据为核心',
          otherTitle: '将数据管理贯穿产品的全生命周期',
          effectDrawing: require('@/assets/images/gn1.png'),
          contentList: [
            {
              title: '物料管理',
              content: '物料编码规则、物料属性定义、物料的生命周期管理、物料分类定义'
            },
            {
              title: 'bom管理',
              content: 'bom结构、替代料管理、bom正反结构查询'
            },
            {
              title: '制造商管理',
              content: '制造商管理、制造商部件号管理'
            },
            {
              title: '文档管理',
              content: '文档分类、文档版本、文档权限等管理'
            }
          ]
        },
        {
          name: 'second',
          label: '变更管理',
          title: '根据用户的个性化需求，支持用户定义各种规则，对变更进行',
          otherTitle: '跟踪和管理',
          effectDrawing: require('@/assets/images/gn2.png'),
          contentList: [
            {
              content: '内置了行业标准的ECR-ECO的工程变更解决方案'
            },
            {
              content: '可以根据客户的个性化需求进行业务流程配置'
            },
            {
              content: '提供了行业领先的用户可编程引擎，支持用户定义各种规则'
            }
          ]
        },
        {
          name: 'third',
          label: '项目管理',
          title: '项目计划＆项目进度＆项目交付＆项目报表',
          effectDrawing: require('@/assets/images/gn3.png'),
          contentList: [
            {
              content: '采用最新的BS技术实现项目中的各种管理功能'
            },
            {
              content: '包含项目计划、交付、资源、工时、费用、报表等核心功能'
            },
            {
              content: '帮助企业实现项目集的管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'four',
          label: '数据建模',
          title: '通过数据建模，支持客户的个性化需求',
          effectDrawing: require('@/assets/images/gn4.png'),
          contentList: [
            {
              content: '提供强大的配置平台，支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限'
            },
            {
              content: '实现完全可配置的业务，支持数据、流程、字段级别的数据建模和精细化的权限控制'
            }
          ]
        },
        {
          name: 'five',
          label: '在线可视化',
          title: '目前支持超过40多种主流的文件格式在线预览，所见即所得',
          effectDrawing: require('@/assets/images/gn5.png'),
          contentList: [
            {
              content: '采用最新的BS架构实现了文件的预览，不需要用户客户端安装任何的客户端软件'
            },
            {
              content: '支持主流2D文件(Office、CAD、压缩文件、文本文件、图片、音频)格式的预览'
            },
            {
              content: '支持主流3D文件(prt、asm、pcb、stp) 格式的预览'
            }
          ]
        },
        {
          name: 'six',
          label: '第三方接入',
          title: '轻松实现与第三方软件的对接',
          effectDrawing: require('@/assets/images/gn6.png'),
          contentList: [
            {
              content: '通过标准的API接口和Webservice接口，实现PLM的数据同企业的其他业务系统和移动办公系统的深度集成'
            },
            {
              content: '自带主流的ERP集成接口和移动端集成，支持数据导出'
            }
          ]

        }
      ],
      schemeList: [
        {
          val: '01',
          label: '化工材料行业',
          title: '应用场景',
          descriptions: [
            '目前，世界范围内化工产业发展迅速，新产品不断推出。同时，市场竞争加剧，产品同质化倾向比较明显，对数字化转型的要求也越来越高。需要覆盖产品全生命周期的闭环研发体系、跨部门跨地域的协同研发体系、基于数据收集和分析的数据建模数据管理体系、以及与第三方系统进行高效对接的系统集成机制。', 
            '璞华易研PLM基于10多年的PLM咨询实施经验，因应化工行业的发展需求，为化工行业提供最佳实践。',
            '我们在化工行业拥有丰富的咨询和实施经验，为客户在激烈的市场竞争中提升产品竞争力。'
          ],
          mainDesc: '化工材料行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '02',
          label: '电子高科技',
          title: '应用场景',
          descriptions: [
            '最近几年，电子高科技行业呈现出激烈的竞争局面，产品上市速度快，具有创新性的产品也不断推出。要在电子产品领域赢得竞争，必须面向消费者、关注设计、富有创新、快速推向市场，产品的全生命周期管理显得越来越重要。',
            '为了因应这一时代潮流，璞华易研PLM关注数据建模和数据管理，通过项目管理和变更管理，推动部门之间、地域之间进行无缝协作，强化与第三方系统的对接，让产品生命周期管理变得快捷、高效。'
          ],
          mainDesc: '电子高科技行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '03',
          label: '芯片半导体',
          title: '应用场景',
          descriptions: [
            '设计成本上涨、产品日益复杂、创新步伐加快，这些均给半导体企业造成很大的压力。该行业研发设计挑战艰巨、生命周期日益缩短。璞华易研PLM，帮助芯片半导体客户极大的改善了新产品开发和生命周期的流程管理。'
          ],
          mainDesc: '芯片半导体行业的PLM应用主要包括以下主要内容',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '04',
          label: '医疗器械',
          title: '应用场景',
          descriptions: [
            '医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。',
            '医疗器械制造商的竞争也日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理方法以及对应的管理平台来迎接这些新挑战。',
          ],
          mainDesc: '医疗器械行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '05',
          label: '工业制造',
          title: '应用场景',
          descriptions: [
            '工业设备等制造业的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研制周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。',
            '企业实施PLM项目管理可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。',
            '璞华易研PLM能帮助企业在管理和工作效率方面得到极大提升，实现上游技术部门和下游生产制造部门之间信息及时传递和共享。'
          ],
          mainDesc: '工业制造行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        }
      ],
      systemInfo: {
        title: '璞华易研PLM的系统功能图',
        description: '璞华易研PLM的系统功能图功能丰富。拥有计算资源层、平台资源层、应用应用层、渠道适配层、接入渠道等多个层级,并与第三方平台进行无缝衔接',
        img: gnt1,
      }
    }
  },
  mounted() {
    this.setSize();
    window.addEventListener("resize", () => {
      this.setSize();
    }, false );
    window.addEventListener("home-scroll-anchor", this.onHomeScrollAnchor);
    window.addEventListener("home-scroll-logo-wall", this.scrollToLogoWall);
    baiduConsult();
    this.tryHomeAnchor();
  },
  beforeDestroy() {
    window.removeEventListener("home-scroll-anchor", this.onHomeScrollAnchor);
    window.removeEventListener("home-scroll-logo-wall", this.scrollToLogoWall);
  },
  watch: {
    "$route.hash": "tryHomeAnchor"
  },
  methods: {
    tryHomeAnchor() {
      this.applyHomeAnchor(this.$route.hash)
    },
    onHomeScrollAnchor(e) {
      const detail = (e && e.detail) || {}
      this.applyHomeAnchor(detail.hash || this.$route.hash, detail.tab)
    },
    applyHomeAnchor(hash, tab) {
      if (hash === "#home-logo-wall") {
        this.scrollToLogoWall()
        return
      }
      if (hash === "#home-characteristic-discrete") {
        this.$nextTick(() => {
          const char = this.$refs.characteristic
          if (char && char.setActiveTab) char.setActiveTab(tab || "second")
        })
        this.scrollToHomeEl("home-characteristic")
      }
    },
    scrollToLogoWall() {
      this.scrollToHomeEl("home-logo-wall")
    },
    scrollToHomeEl(id) {
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (!el) return;
        const header = document.querySelector(".srm-header");
        const offset = header ? header.offsetHeight : 56;
        const go = () => {
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        };
        setTimeout(go, 80);
        setTimeout(go, 400);
      });
    },
    skip(num) {
      const arr = ['header', 'carouselContainer', 'advantage',
        'characteristic', 'appBenefits',
        'customForm']
      const useArr = arr.splice(0, num)
      let top = 0;
      useArr.forEach((ele, index) => {
        const el = this.$refs[ele]
        if (index === 0) top -= el.$el.clientHeight
        else top += el.$el.clientHeight
      })
      window.scrollTo({
        top,
        left: 0,
        behavior: "smooth"
      })
    },
    setSize() {
      const w = document.body.clientWidth
      this.bannerHeight = w / (1920 / 780)
      this.bannerHeight2 = w / (1920 / 558)
      if (w < 768) {
        this.bannerHeight = 460
        this.bannerHeight2 = 280
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

::v-deep .systemFunction-container {
  padding: 9rem 24.3rem 1.5rem;
  .description{
    margin-bottom: 3.3rem;
  }
}

@include mobile {
  ::v-deep .systemFunction-container {
    padding: 4.8rem 1.6rem 1.5rem;
  }
}
</style>
